import { createFileRoute } from "@tanstack/react-router";
import Auth from "@/pages/Auth";
import { AuthProvider } from "@/contexts/AuthContext";
import { Toaster } from "@/components/ui/toaster";
import { pageHead } from "@/lib/seo";

export const Route = createFileRoute("/auth")({
  head: () =>
    pageHead({
      path: "/auth",
      title: "Connexion | CMO Partner",
      description: "Espace de connexion CMO Partner.",
      enPath: null,
      noindex: true,
    }),
  component: () => (
    <AuthProvider>
      <Toaster />
      <Auth />
    </AuthProvider>
  ),
});
